import { SharedComponentsModule } from './components/shared-components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule, SharedComponentsModule],
  exports: [SharedComponentsModule],
})
export class SharedModule {}
